import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { useClearSearchParam } from './useClearSearchParam';

/**
 * Clear Search Param on Value hook
 * Remove a search param value from the URL string when it matches an expected value.
 * @param paramName Search param key/name to possibly remove
 * @param expectedUnsetValue Value to test param against
 */
export const useClearSearchParamOnValue = (paramName: string, expectedUnsetValue: string) => {
  const location = useLocation();
  const [shouldUnset, setShouldUnset] = useState(false);

  useClearSearchParam(paramName, shouldUnset);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const newValue = urlParams.get(paramName) === expectedUnsetValue;

    if (shouldUnset !== newValue) {
      setShouldUnset(newValue);
    }
  }, [location, paramName, expectedUnsetValue, shouldUnset]);
};
